import React from 'react';
import { StarIcon } from 'lucide-react';
export function HeroTestimonial() {
  return <section className="py-6 md:py-8 border-b border-gray-200" data-id="element-57">
      <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-center" data-id="element-58">
        <div className="w-full md:w-1/2" data-id="element-59">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tPe8FwTtazWtq6H3tyUWag/Untitled_design_%2842%29.png" alt="Smiling man holding Vascura bottle" className="w-full h-auto rounded-lg shadow-lg" data-id="element-60" />
        </div>
        <div className="w-full md:w-1/2 mt-4 md:mt-0" data-id="element-61">
          <blockquote className="text-lg md:text-xl italic text-gray-700 mb-3 md:mb-4" data-id="element-62">
            "I felt drained, cold, and out of control. Since starting Vascura,
            my energy's back, my blood pressure's steady, and my hands are not
            numb and warm again"
          </blockquote>
          <div className="flex items-center mb-2" data-id="element-63">
            <div className="flex text-yellow-400" data-id="element-64">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 md:w-5 md:h-5 fill-current" data-id="element-65" />)}
            </div>
            <span className="ml-2 text-xs md:text-sm text-gray-500" data-id="element-66">
              Verified Customer
            </span>
          </div>
          <p className="font-medium text-sm md:text-base" data-id="element-67">
            — Robert Martinez, 47, Texas
          </p>
        </div>
      </div>
    </section>;
}